import React from 'react'
import withStyles from 'isomorphic-style-loader/withStyles'
import * as styles from './_DistanceToAdviser.scss'
import PropTypes from 'prop-types';

const makeLocationGoogleMapsCompliant = (location) => {
  while (location.indexOf('&') > -1 || location.indexOf(' ') > -1) {
    location = location.replace('&', '%26').replace(' ', '+')
  }
  return location
}

const DistanceToAdvisorMobile = (hasDistance, mapsUrl, km) => {
  return (
    <span className={styles['distance-to-adviser-compact']} >
      { hasDistance ? <a style={{cursor: 'pointer'}} href={mapsUrl} target='_blank'><h2 className={styles['compact-km']}>{km}km from your location</h2></a> : '' }
      { hasDistance ? <div /> : <div className={styles['view-on-map-link']}><a href={mapsUrl} target='blank'>View on map</a></div> }
    </span>
  )
}

const DistanceToAdvisorDesktop = (hasDistance, mapsUrl, km) => {
  return (
    <span className={styles['distance-to-adviser']} >
      { hasDistance ? <h2><a style={{cursor: 'pointer'}} href={mapsUrl} target='_blank'>{km}km</a></h2> : '' }
      { hasDistance ? <div className={styles['from-your-location']}> <a style={{cursor: 'pointer'}} href={mapsUrl} target='_blank'>from your location</a> </div> : <div className={styles['view-on-map-link']}><a href={mapsUrl} target='blank'>View on map</a></div> }
    </span>
  )
}

class DistanceToAdviser extends React.Component {
  static propTypes = {
    distanceToAdviser: PropTypes.string,
    fromLocation: PropTypes.string.isRequired,
    toLocation: PropTypes.string.isRequired,
    compact: PropTypes.bool
  };

  render () {
    const distance = this.props.distanceToAdviser
    let hasDistance = !!distance && isNaN(distance) && distance.indexOf('Unknown') < 0
    var kmIndex
    var km = 'View on map'
    if (hasDistance) {
      kmIndex = distance.indexOf('km')
      km = distance.substr(0, kmIndex).replace(' ', '').replace(',', '')
      if (km <= 0) {
        km = 0
        hasDistance = true
      } else {
        km = parseInt(km)
      }
    }
    var mapsUrl = `https://maps.google.co.za/maps?saddr=${makeLocationGoogleMapsCompliant(this.props.fromLocation)}&daddr=${makeLocationGoogleMapsCompliant(this.props.toLocation)}`
    const compact = this.props.compact
    return <span>
      {compact ? DistanceToAdvisorMobile(hasDistance, mapsUrl, km) : DistanceToAdvisorDesktop(hasDistance, mapsUrl, km)}
    </span>
  }
}

export default (DistanceToAdviser)
